
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { getLetters} from "../../../../globals";

@Component({
  selector: 'service-assign',
  templateUrl: '../../templates/partials/assign-service.html'
})
export class AssignServiceComponent{

    @Input() cleanersAvailability: Array<object>;
    @Input() cleaner: Array<object>;
    @Input() service;
    @Output() assignCleanerEmitter = new EventEmitter();
    @Output() sendToAppEmitter = new EventEmitter();
    public letters: Array<object>;
    public indexActive = null;
    public letterSelected = null;

    constructor(){
        this.letters = getLetters();
    }

    public setClass(hour){
        if(hour.available == "notAvailable"){
            return ""
        }
        else if(hour.available == "available"){
            return "c-select-hours-cleaner__item--active";
        }
        else if(hour.available == "busy"){
            return "c-select-hours-cleaner__item--selected-" + hour.duration;
        }
        else if(hour.available == "selection"){
            var disabled = "";
            if(this.cleaner["cleaner_id"] == null) disabled = "c-select-hours-cleaner__disabled"
            return "c-select-hours-cleaner__item--selection-" + hour.duration + " " + "c-select-hours-cleaner__disabled";
        }

    }

    public assignCleaner(hour,cleaner) {
        if(hour["available"] == "selection" || hour == "early"){
            if(this.cleaner["cleaner_id"] == null){
                this.assignCleanerEmitter.emit(cleaner);
            }
        }
    }

    public ToApp(cleaner: object) {
        this.sendToAppEmitter.emit(cleaner["id_professional"]);
    }

    public setLetterActive(letter: string, index: number){
        if(letter == this.letterSelected){
            this.indexActive = null;
            this.letterSelected = null;
        }else{
            this.indexActive = index;
            this.letterSelected = letter;
        }
    }

}


// WEBPACK FOOTER //
// ./src/app/modules/services/components/dummy/assign-service.component.ts